import axios from "axios";
import { addToQueue } from "@/lib/offlineQueue";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_URL}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Offline queue — for POST/PUT requests that fail due to network issues
const QUEUEABLE_METHODS = ["post", "put"];
const QUEUEABLE_URLS = ["/laporan", "/tambak", "/siklus", "/gudang", "/panen", "/keuangan"];

function isQueueable(config) {
  if (!config) return false;
  const method = config.method?.toLowerCase();
  if (!QUEUEABLE_METHODS.includes(method)) return false;
  return QUEUEABLE_URLS.some((u) => config.url?.startsWith(u));
}

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const isAuthRoute = error.config?.url?.includes("/auth/");

    // Network error — try to queue for later sync
    if (!error.response && isQueueable(error.config) && !navigator.onLine) {
      try {
        await addToQueue({
          method: error.config.method,
          url: error.config.url,
          data: error.config.data ? JSON.parse(error.config.data) : null,
        });
        return Promise.reject({
          ...error,
          offlineQueued: true,
          message: "Data disimpan di antrian offline",
        });
      } catch { /* fall through */ }
    }

    if (error.response?.status === 401 && !error.config._retry && !isAuthRoute) {
      error.config._retry = true;
      try {
        const { data } = await axios.post(`${API_URL}/api/auth/refresh`, {}, { withCredentials: true });
        localStorage.setItem("token", data.token);
        error.config.headers.Authorization = `Bearer ${data.token}`;
        return api(error.config);
      } catch {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
      }
    }
    return Promise.reject(error);
  }
);

export default api;
